import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Datatemplate extends Component {
 
  render() {
    const course =[
      {
        title: "Introduction to Data Science",
        content: [
        "Overview of Data Science",
        "Data Science Process",
        "Tools and Technologies",
        "Data Science Applications",
        "Data Science Ethics"
        ]
        },
        {
        title: "Data Collection and Preprocessing",
        content: [
        "Data Collection Techniques",
        "Data Preprocessing Techniques",
        "Data Cleaning and Transformation",
        "Data Integration and Aggregation",
        "Data Wrangling"
        ]
        },
        {
        title: "Exploratory Data Analysis",
        content: [
        "Descriptive Statistics",
        "Data Visualization",
        "Correlation and Regression",
        "Hypothesis Testing",
        "Dimensionality Reduction"
        ]
        },
        {
        title: "Machine Learning Fundamentals",
        content: [
        "Supervised Learning",
        "Unsupervised Learning",
        "Semi-Supervised Learning",
        "Reinforcement Learning",
        "Ensemble Learning"
        ]
        },
        {
        title: "Regression Analysis",
        content: [
        "Linear Regression",
        "Multiple Regression",
        "Logistic Regression",
        "Ridge Regression",
        "Lasso Regression"
        ]
        },
        {
        title: "Classification and Clustering",
        content: [
        "Decision Trees",
        "Random Forest",
        "Naive Bayes",
        "K-Nearest Neighbors",
        "K-Means Clustering"
        ]
        },
        {
        title: "Natural Language Processing",
        content: [
        "Text Preprocessing",
        "Text Classification",
        "Named Entity Recognition",
        "Sentiment Analysis",
        "Topic Modeling"
        ]
        },
        {
        title: "Deep Learning",
        content: [
        "Neural Networks",
        "Convolutional Neural Networks",
        "Recurrent Neural Networks",
        "Autoencoders",
        "Generative Adversarial Networks"
        ]
        },
        {
        title: "Big Data Analytics",
        content: [
        "Introduction to Big Data",
        "Hadoop and Spark",
        "MapReduce",
        "Hive and Pig",
        "Apache Cassandra"
        ]
        },
        {
        title: "Data Science Tools and Technologies",
        content: [
        "Python Programming",
        "R Programming",
        "Data Science Libraries",
        "Data Science Platforms",
        "Data Science in Cloud"
        ]
        },
        {
        title: "Data Science Project",
        content: [
        "Project Planning",
        "Data Collection and Preprocessing",
        "Data Analysis and Visualization",
        "Machine Learning Modeling",
        "Project Deployment and Presentation"
        ]
        },
        {
        title: "Data Science Ethics and Privacy",
        content: [
        "Data Privacy",
        "Data Ownership",
        "Data Governance",
        "Data Security",
        "Ethical Considerations"
        ]
        }
    ]

    const faqData = [
      {
        question: 'What is Data Science Training?',
        answer:
          'Data Science Training is a specialized program designed to equip individuals with the skills and knowledge required to extract insights and value from large datasets using various techniques and tools.',
      },
      {
        question: 'Why is Data Science Training important?',
        answer:
          `Data Science Training is crucial for professionals seeking to harness the power of data to make informed business decisions, drive innovation, and gain a competitive edge in today's data-driven world.`,
      },
      {
        question: '"How is data science related to other fields such as artificial intelligence and machine learning?"',
        answer:
          'Data science is closely related to artificial intelligence and machine learning, as it involves using statistical and mathematical techniques to extract insights from data, and building models and algorithms to automate and optimize tasks such as prediction and classification.',
      },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'A person with data science skills can pursue a variety of career opportunities such as Data Scientist, Machine Learning Engineer, Data Analyst, Business Intelligence Analyst, Data Engineer, and Data Architect.',
      },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"Embark on a transformative journey into the world of data science at the Best Training Centre. Our comprehensive program warmly welcomes individuals from diverse backgrounds, offering them the opportunity to acquire the skills and knowledge necessary to excel in the field of data science. Whether you're a recent graduate, an experienced professional, or someone looking to make a career transition, our courses cater to learners at every level of expertise. With a strong emphasis on practical learning and real-world projects, our expert instructors guide you through essential data science concepts, including statistical analysis, machine learning, data visualization, and big data technologies."
      },
      {
        cnt:"At the Best Training Centre, we prioritize inclusivity and accessibility, ensuring that learners of all backgrounds have the opportunity to unlock their potential in data science with the best training centre. Join us and take your career to new heights with data science training at the best training centre."
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Rihaan",
          date:" july 09 ,2023",
          review:` learnsoft.org has earned a reputation as a leading platform for ${this.props.title} training in ${this.props.location}. Their programs are designed to provide a comprehensive understanding of ${this.props.title} modules, making them a top choice for HR professionals.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Ananya",
          date:" july 29 ,2023",
          review:`${this.props.title}, staying informed about the latest trends, tools, and best practices is essential. learnsoft.org recognizes this need and provides a dedicated section for ${this.props.title} reviews.`
      },
  ]
    return(
      <>
      
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="Data science is the study of data to extract meaningful insights for business. It is a multidisciplinary approach that combines principles and practices from the fields of mathematics, statistics, artificial intelligence, and computer engineering to analyze large amounts of data."/> */}
          <NewMainsec rating='4.9' students={"546"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1}  intro="Data science is the study of data to extract meaningful insights for business. It is a multidisciplinary approach that combines principles and practices from the fields of mathematics, statistics, artificial intelligence, and computer engineering to analyze large amounts of data."/>
            <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		<Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`Data Science is a rapidly growing field with a high demand for skilled professionals. At Learnsoft.org, we offer top-quality Data Science training courses in ${this.props.location} to help individuals enhance their skills and gain a comprehensive understanding of Data Science principles and practices. Our experienced trainers use a hands-on approach, incorporating real-world scenarios and practical exercises to provide a well-rounded education. Whether you're new to Data Science or looking to expand your skillset, Learnsoft.org's Data Science ${this.props.location1} is the perfect choice to take your career to the next level. Contact us today to learn more about our courses and start your Data Science journey.`} 
    title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our Data Science course covers a wide range of topics, including statistical analysis, data mining, machine learning, and data visualization. Our experienced trainers will guide you through hands-on exercises and real-world scenarios to help you understand the concepts and techniques used in Data Science. By the end of the course, you will be able to implement Data Science practices in your own projects."}/>
           </section>
 <Batchtime title={this.props.title} fees="25,999" offer="18,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
          <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>
       <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou2="Java" coupath2="java" cou3='R Programming' coupath3='rprogram' cou10='Full Stack Developer' coupath10='full-stack-developer' cou6='AngularJS' coupath6='angularjs' cou9='Front End Developer' coupath9='front-end-developer'
          cou5='ReactJS' coupath5='reactjs' cou='JavaScript' coupath='javascript' cou7='Katalon' coupath7='katalon'
          cou1='Python' coupath1='python' cou8='Flutter' coupath8='flutter'  cou4='Go' coupath4='go' />
        
      </>
    );
  }
}
